/** Marca de kill switch: desligamento de emergência, só liga e desliga, nunca arquivado. */
export function KillSwitchBadge() {
  return (
    <span
      className="badge badge-warning"
      title="Kill switch: só liga e desliga, sem percentual, e não pode ser arquivada."
      style={{ marginLeft: 8 }}
    >
      kill switch
    </span>
  );
}
